import { ResponseSuccess } from '@forwardflow/types'
import { apiPost } from './Axios/configs'

export type HandoffPurpose =
   | 'payment'
   | 'fub-connection'
   | 'calendar-connection'

export interface RedeemedHandoff {
   id: string
   organizationId: string
   userId: number
   purpose: HandoffPurpose
   onboardingRevision: number
   expiresAt: string
   /** Whether setup moved between the link being made and being opened. */
   onboardingChangedSince: boolean
}

export class OnboardingHandoffService {
   /**
    * Redeem a handoff reference, ONCE, as the signed-in person.
    *
    * The reference is navigation context: it says which task the person came
    * to finish. It carries no authority — the backend decides from this
    * browser's own session, so a link forwarded to somebody else does nothing
    * for them. `includeXOrg` is false because the organization is a property
    * of the reference, not of whatever this tab last selected.
    */
   static async redeem(handoffId: string) {
      const data = await apiPost<ResponseSuccess<RedeemedHandoff>>({
         apiPath: `/organizations/onboarding-handoff/${encodeURIComponent(
            handoffId,
         )}/redeem`,
         includeXOrg: false,
      })
      return data || undefined
   }
}
